import View from "../../../Nav/Js/views/common/TabbedListAnchorView";
import components from "./components.js";
components.define("js-TabbedListAnchor", View);